import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=a37b2c5c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=a37b2c5c&prod&lang=less&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=a37b2c5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37b2c5c",
  null
  
)

export default component.exports